<template>
  <v-system-bar
    v-if="shouldShowBar"
    id="verified-status"
    app
    height="42"
  >
    <v-spacer />
    <span>Your email is not yet verified. Until you verify your email some functionality will be unavailable.</span>
    <v-btn
      depressed
      small
      @click.stop="sendEmailVerification"
    >
      Resend Email Verification
    </v-btn>
    <v-spacer />
  </v-system-bar>
</template>

<script>
import { auth } from '../firebase'
export default {
  name: 'EmailVerification',
  props: {
    daysAfterToShowNotice: {
      type: Number,
      default: 2
    }
  },
  computed: {
    shouldShowBar: function () {
      if (this.user.uid && !this.user.emailVerified) {
        return true
      }
      return false
    }
  },
  beforeCreate() {
    this.dispatchActions(['checkAuth', 'get_appUser'])
    this.mapStates(['user', 'appUser', 'appUserBinding'])
  },
  async created() {
    await this.appUserBinding
    if (!this.user.emailVerified && !this.appUser.emailVerificationSent) {
      await this.sendEmailVerification()
    }
  },
  methods: {
    async sendEmailVerification() {
      await auth.currentUser.sendEmailVerification()
      await this.$api.sentEmailVerification()
    }
  }
}
</script>

<style>
#verified-status {
  background-color: rgb(250, 227, 180);
  color: black;
}
#verified-status span {
  padding-right: 0.75em;
}
</style>
